import React, { useEffect, useCallback } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from '@mui/material';
import { Delete as DeleteIcon, Send as SendIcon } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-final-form';

import { TextField } from '../common/Fields';
import { Content } from '../layout';

import {
  getNoticeMacro,
  submitNoticeMacro,
  updateNoticeMacro,
  deleteNoticeMacro,
  fetchNoticeMacros,
} from '../../actions';

const NoticeMacroForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { noticeMacro } = useSelector((state) => state.noticeMacro);

  useEffect(() => {
    dispatch(fetchNoticeMacros());
    if (id) {
      dispatch(getNoticeMacro(id));
    }
  }, [id, dispatch]);

  const onSubmit = useCallback(
    (noticeMacro) => {
      if (id) {
        dispatch(updateNoticeMacro({ noticeMacro, id }, navigate));
      } else {
        dispatch(submitNoticeMacro({ noticeMacro }, navigate));
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteNoticeMacro({ id }, navigate));
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        macroId: noticeMacro?.macroId,
        subject: noticeMacro?.subject,
        content: noticeMacro?.content,
      }}
      validate={(values) => {
        const { macroId, subject, content } = values;
        const errors = {};
        if (!macroId) {
          errors.macroId = '필수';
        }
        if (!subject) {
          errors.subject = '필수';
        }
        if (!content) {
          errors.content = '필수';
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  공지사항 매크로
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <TextField
                      // required={true}
                      variant="standard"
                      name="macroId"
                      type="text" // number?
                      label="매크로 ID"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="subject"
                      type="text"
                      label="제목"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="content"
                      type="text"
                      label="내용"
                      // textarea={true}
                      multiline
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default NoticeMacroForm;
